'use client'

import { Toaster } from '@/components/ui/toaster'
import { Toaster as SonnerToaster } from 'sonner'
import { SocketProvider } from '@/contexts/SocketContext'
import { TimezoneProvider } from '@/contexts/TimezoneContext'

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <TimezoneProvider>
      <SocketProvider>
        {children}
        <Toaster />
        <SonnerToaster 
          theme="dark"
          position="top-right"
          toastOptions={{
            style: {
              background: 'rgb(30 41 59)',
              border: '1px solid rgb(51 65 85)',
              color: 'rgb(248 250 252)',
            },
          }}
        />
      </SocketProvider>
    </TimezoneProvider>
  )
}